import Breadcrumb from '@/components/base/Breadcrumb';
import { usePageMeta } from '@/hooks/usePageMeta';
import FeedbackForm from './components/FeedbackForm';

const values = [
  { icon: 'ri-file-list-3-line', title: '剧情梳理清楚', desc: '把零散的剧情信息整理成清晰的时间线与要点，方便快速理解作品全貌。' },
  { icon: 'ri-user-heart-line', title: '角色资料详实', desc: '为每个主要角色建立独立资料页，涵盖背景、性格与关键剧情点。' },
  { icon: 'ri-search-eye-line', title: '内容便于检索', desc: '支持影视作品与角色双重搜索，配合分类筛选，快速定位想看的内容。' },
  { icon: 'ri-shield-check-line', title: '纯粹浏览体验', desc: '无登录、无支付、无广告干扰，只专注于内容本身的阅读与查阅。' },
];

export default function About() {
  usePageMeta(
    '关于我们 - 玉女心经2',
    '了解玉女心经2 影视内容站的定位、内容范围与联系方式，我们专注影视剧情介绍、角色分析与背景资料整理。'
  );

  return (
    <div className="w-full bg-background-50 px-4 md:px-8 py-8 md:py-12">
      <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />

      <div className="mt-5 max-w-3xl">
        <h1 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">关于我们</h1>
        <p className="mt-3 text-sm leading-7 text-foreground-600">
          玉女心经2 影视内容站，是一处专注影视剧情与角色资料的整理平台。
        </p>
      </div>

      {/* 站点定位 */}
      <section className="mt-8 overflow-hidden rounded-lg border border-background-200/70 bg-background-100">
        <div className="grid grid-cols-1 md:grid-cols-2">
          <div className="p-6 md:p-8">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 font-label text-xs text-primary-700">
              <i className="ri-flag-line"></i> 站点定位
            </span>
            <h2 className="mt-4 font-heading text-xl font-black text-foreground-950 md:text-2xl">把影视内容讲清楚</h2>
            <p className="mt-4 text-sm leading-8 text-foreground-700">
              我们面向喜欢详细剧情梳理、角色分析与影视资讯的观众与影迷。网站以《玉女心经2》为核心，逐步收录更多影视作品，围绕剧情介绍、角色信息与作品背景，提供系统、整洁、可检索的内容。
            </p>
            <p className="mt-3 text-sm leading-8 text-foreground-700">
              这里不提供在线播放、会员或交易功能，只做一件事——帮助你更全面、更轻松地了解一部作品。
            </p>
          </div>
          <div className="border-t border-background-200/70 p-6 md:border-l md:border-t-0 md:p-8">
            <h3 className="font-heading text-base font-bold text-foreground-950">内容范围</h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              {[
                '影视作品基础信息：导演、主演、类型、年代、时长',
                '剧情简介与背景资料梳理',
                '角色资料：背景介绍、性格分析与关联剧情点',
                '影视专题：剧情解析、角色深挖与世界观考据',
              ].map((item) => (
                <li key={item} className="flex gap-2">
                  <i className="ri-check-line mt-1 text-primary-600"></i>
                  <span className="leading-7">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* 内容原则 */}
      <section className="mt-10">
        <h2 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">我们坚持的原则</h2>
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v) => (
            <div key={v.title} className="rounded-lg border border-background-200/70 bg-background-100 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${v.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{v.title}</h3>
              <p className="mt-2 text-sm leading-7 text-foreground-600">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 联系方式 + 反馈 */}
      <section className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="lg:col-span-1">
          <h2 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">联系我们</h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            如果你有内容建议、资料纠错或合作咨询，欢迎通过以下方式与我们联系。
          </p>

          <div className="mt-6 space-y-4">
            <div className="flex items-start gap-3 rounded-lg border border-background-200/70 bg-background-100 p-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-mail-line text-lg"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500">联系邮箱</p>
                <p className="mt-0.5 text-sm font-medium text-foreground-900">contact@yunuxinjing2.example</p>
              </div>
            </div>
            <div className="flex items-start gap-3 rounded-lg border border-background-200/70 bg-background-100 p-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className="ri-feedback-line text-lg"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500">在线反馈</p>
                <p className="mt-0.5 text-sm leading-6 text-foreground-700">
                  也可直接使用右侧的反馈表单留言，我们会通过你留下的邮箱回复。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-2">
          <h2 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">在线反馈</h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            填写下面的表单给我们留言，带 <span className="text-accent-600">*</span> 的为必填项，留言不超过 500 字。
          </p>
          <div className="mt-6">
            <FeedbackForm />
          </div>
        </div>
      </section>
    </div>
  );
}